import { AppDebug, AppDebugLogType } from "../debug/AppDebug";

export type PLDTrackingGameLoadType = () => void;
export type PLDTrackingLevelStartType = (gamemode: string, continueOrNewGame: string) => void;
export type PLDTrackingLevelCompletionType = (score: string, time:number, winOrLoss: string, dealOrGame: string) => void;
export type PLDTrackingMainMenuType = () => void;
export type PLDTrackingMenuType = (menu: string) => void;
export type PLDTrackingSettingChangedType = (setting: string, value: string) => void;

export type TrackingSettingChangedDataType = { setting: string, value: string };

export enum GTMTrackingDealWinOrLoss {
    WIN = "win",
    LOSS = "loss",
    TIE = "tie"
}
export enum GTMTrackingCompleteDealOrGame {
    DEAL = "deal",
    GAME = "game"
}
export enum GTMTrackingContinueOrNewGame {
    NEW = "new",
    CONTINUE = "continue"
}


/**
 * @see VariationIds
 */
// export enum GTMTrackingGameModes {}

/**
 * Give access to global Google Tag Manager Tracking JS function calls defined in window scope
 */
export class GTMTracking
{
    /**
     * PLDTrackingGameLoad()
     * 'event' : 'gameLoad'
     * trigger when the game is fully loaded in the browser
     */
    public static PLDTrackingGameLoad: PLDTrackingGameLoadType;
    /**
     * PLDTrackingLevelStart(gamemode:string)
     * gamemode values: peek variations.json
     * 'event' : 'levelStart'
     * trigger when player chooses to play/restart/new variation (NOT continue)
     */
    public static PLDTrackingLevelStart: PLDTrackingLevelStartType;
    /**
     * PLDTrackingLevelCompletion(score:number, time:number, winOrLoss:string)
     * 'event' : 'levelStart'
     * trigger as soon as the game over or game win screen is displayed to player
     */
    public static PLDTrackingLevelCompletion: PLDTrackingLevelCompletionType;
    /**
     * PLDTrackingMainMenu()
     * 'event' : 'mainMenu'
     * trigger when main menu shows (after loading the game or when player return to the main menu)
     */
    public static PLDTrackingMainMenu: PLDTrackingMainMenuType;
    public static PLDTrackingMenu: PLDTrackingMenuType;
    /**
     * PLDTrackingSettingChanged(setting:String, value:String)
     * 'event' : 'settingChanged'
     * NOTE: code inside this function: leave empty for now – trigger whenever player manually changes 
     *       a setting in the game e.g. card pack, cards back style, table background, music, language,
     *       music on/off, sounds on/off
     */
    public static PLDTrackingSettingChanged: PLDTrackingSettingChangedType;

    /**
     * 
     */
    public static Init():void
    {
        const debug: boolean = AppDebug.IsDebug();
        
        this.PLDTrackingGameLoad = ()=>{
            AppDebug.log('PLDTrackingGameLoad', AppDebugLogType.GTM);
            (window["PLDTrackingGameLoad"] as PLDTrackingGameLoadType)();
        }
        this.PLDTrackingLevelStart = (gamemode: string, continueOrNewGame: string)=>{
            AppDebug.log('PLDTrackingLevelStart; gamemode='+gamemode+'; continueOrNewGame='+continueOrNewGame, AppDebugLogType.GTM);
            (window["PLDTrackingLevelStart"] as PLDTrackingLevelStartType)(gamemode, continueOrNewGame);
        }
        this.PLDTrackingLevelCompletion = (score: string, time: number, winOrLoss: string, dealOrGame: string)=>{
            AppDebug.log('PLDTrackingLevelCompletion; score='+score+'; time='+time+'; winOrLoss='+winOrLoss+'; dealOrGame='+dealOrGame, AppDebugLogType.GTM);
            (window["PLDTrackingLevelCompletion"] as PLDTrackingLevelCompletionType)(score, time, winOrLoss, dealOrGame);
        }
        this.PLDTrackingMainMenu = ()=>{
            AppDebug.log('PLDTrackingMainMenu', AppDebugLogType.GTM);
            (window["PLDTrackingMainMenu"] as PLDTrackingMainMenuType)();
        }
        this.PLDTrackingMenu = (menu: string)=>{
            AppDebug.log('PLDTrackingMenu; menu='+menu, AppDebugLogType.GTM);
            (window["PLDTrackingMenu"] as PLDTrackingMenuType)(menu);
        }
        this.PLDTrackingSettingChanged = (setting: string, value: string)=>{
            AppDebug.log('PLDTrackingSettingChanged; setting='+setting+'; value='+value, AppDebugLogType.GTM);
            (window["PLDTrackingSettingChanged"] as PLDTrackingSettingChangedType)(setting, value);
        }
    }
}